import React, { useState } from "react";
import RangeDatePicker from "shared/components/rangeDatePicker";
import styles from "./style.module.scss";

function PlansAccountsInFigure() {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());

  const accounts_stats = [
    {
      label: "Kids Account",
      value: 143382,
    },
    {
      label: "Parent Accounts",
      value: 87974,
    },
    {
      label: "School Accounts",
      value: 45211,
    },
  ];
  return (
    <div className={styles.mainContainer}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>Most Premium Accounts</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <RangeDatePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            labelStyle={styles.dateLabel}
          />
        </div>
      </div>

      <div className={styles.progressContainer}>
        {accounts_stats?.map((item) => {
          return (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <label className={styles.heading}>{item?.label}</label>
                <label className={styles.barValue}>
                  {(item?.value).toLocaleString()}
                </label>
              </div>
              <progress
                value={item?.value}
                max={143382}
                className={styles.progress}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PlansAccountsInFigure;
